import { Play, Pause, X } from "lucide-react";
import { formatTime } from "../../utils/formatTime";

export const MiniPlayer = ({ track, currentTime, duration, isPlaying, onTogglePlay, onExpand, onClose }) => {
  const progressPercent = duration > 0 ? (currentTime / duration) * 100 : 0;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[92vw] sm:w-[420px] z-50">
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        title="Cerrar reproductor"
        aria-label="Cerrar reproductor"
        className="absolute -top-2.5 -right-2.5 z-10 w-7 h-7 rounded-full bg-[#ff2d55] hover:bg-[#ff1744] flex items-center justify-center text-white shadow-lg transition-colors"
      >
        <X size={14} strokeWidth={2.5} />
      </button>

      <div
        onClick={onExpand}
        className="rounded-2xl px-3 py-2.5 flex items-center gap-3 cursor-pointer shadow-2xl"
        style={{
          background: "linear-gradient(105deg,#e0217a 0%,#a01a72 55%,#5c1a6b 100%)",
          border: "1px solid rgba(255,255,255,.18)",
          backdropFilter: "blur(18px)",
        }}
      >
        <div
          className="w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0 overflow-hidden"
          style={{ background: "#d2d2d2" }}
        >
          <img src="/logo192.png" alt="El Medio" className="w-full h-full object-contain p-1" />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-1.5 min-w-0">
            <p className="text-[13px] font-semibold text-white truncate">{track.name}</p>
            <span className="text-[9px] text-white/40 uppercase tracking-wide shrink-0">
              {track.type === "completo" ? "Completo" : "Resumen"}
            </span>
          </div>
          <p className="text-[11px] font-mono text-white/55 mt-0.5">
            {formatTime(currentTime)} / {formatTime(duration)}
          </p>
          <div className="h-[2px] rounded-full bg-white/25 mt-1.5 overflow-hidden">
            <div className="h-full bg-white" style={{ width: `${progressPercent}%` }} />
          </div>
        </div>

        <button
          onClick={(e) => {
            e.stopPropagation();
            onTogglePlay();
          }}
          className="w-9 h-9 rounded-full bg-white flex items-center justify-center shrink-0 text-[#e0217a] shadow-md"
        >
          {isPlaying ? <Pause size={14} fill="currentColor" /> : <Play size={14} fill="currentColor" />}
        </button>
      </div>
    </div>
  );
};
